export const AxiosError = (navigate, error) => {
    if (error?.response?.data) {
        const { status_code, err } = error.response.data;

        if (Number(status_code) === 403 && err === "Invalid token and Token Expired") {
            console.log("Token expired. Redirecting to login...");
            navigate("/login");  
        } else {
            navigate("/login");
        }
    } else {
        console.log("Unexpected error:", error);
        navigate("/login");
    }
};
